<template>
  <v-dialog
    :value="value"
    persistent
    max-width="700px"
    @click:outside="closeModal">
    <v-card>
      <v-card-title>
        <v-icon color="primary">mdi-store</v-icon>
        <span class="pl-2">{{ storeParty.store_name }}</span>
        <v-spacer/>
        <v-btn icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="stores"
        :height="250"
        :items-per-page="-1"
        dense
        hide-default-footer>
        <template #item.store_name="{ item }">
          <td class="noWrap">{{ item.store_name }}</td>
        </template>
        <template #item.start_dt="{ item }">
          <td class="noWrap">{{ formatDateDisplay(item.start_dt) }}</td>
        </template>
        <template #item.end_dt="{ item }">
          <td class="noWrap">{{ formatDateDisplay(item.end_dt) }}</td>
        </template>
        <template #item.created_on="{ item }">
          <td class="noWrap">{{ formatDateDisplay(item.created_on) }}</td>
        </template>
      </v-data-table>
      <label class="font-weight-light mx-2">Note: The primary store of a store group is determined by the store relationship's start date.</label>
    </v-card>
  </v-dialog>
</template>
<script>
import { displayHelpers } from '@/mixins/displayHelpers'

export default {
  name: 'StoreGroupModal',
  mixins: [displayHelpers],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    storeParty: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      headers: [
        { text: 'Store Name', value: 'store_name', class: 'accent white--text', align: 'start' },
        { text: 'Start Date', value: 'start_dt', class: 'accent white--text' },
        { text: 'End Date', value: 'end_dt', class: 'accent white--text' },
        { text: 'Created On', value: 'created_on', class: 'accent white--text' }
      ]
    }
  },
  computed: {
    stores () {
      return this.storeParty.children || []
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:value', false)
    }
  }
}
</script>